import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=a779906c&scoped=true"
import script from "./VideoIcon.vue?vue&type=script&lang=ts"
export * from "./VideoIcon.vue?vue&type=script&lang=ts"
import style0 from "./Icons.scss?vue&type=style&index=0&id=a779906c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a779906c",
  null
  
)

export default component.exports